import { OPERATION_MODE_STORED_KEY } from "../../store/constants";
import { OperationMode } from "../enums/operation-mode";

export function readStoredOperationMode(): OperationMode | null {
  const stored = localStorage.getItem(OPERATION_MODE_STORED_KEY);
  return stored === OperationMode.Sowing || stored === OperationMode.Harvesting
    ? stored
    : null;
}

export function writeStoredOperationMode(mode: OperationMode | null): void {
  if (mode) {
    localStorage.setItem(OPERATION_MODE_STORED_KEY, mode);
  } else {
    localStorage.removeItem(OPERATION_MODE_STORED_KEY);
  }
}
